// extracted by mini-css-extract-plugin
export default {"pdf_document":"PdfDocument_pdf_document__Y-qju","pdf_document__react_pdf":"PdfDocument_pdf_document__react_pdf__DtLfq"};